export default __webpack_public_path__ + "static/media/atlasLogo.66179b30.png";